<template>
  <v-row>
    <v-col>
      <v-menu
        ref="datepicker"
        :close-on-content-click="false"
        v-model="datepicker"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :rules="[validDate]"
            v-model="date"
            label="Händelsedatum"
            outlined
            v-bind="attrs"
            v-on="on"
            hint="Obligatorisk"
            persistent-hint
            :disabled="readonly"
          />
        </template>
        <v-date-picker
          locale="sv"
          first-day-of-week="1"
          v-model="date"
          no-title
          @input="datepicker = false"
        />
      </v-menu>
    </v-col>
    <v-col cols="4">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        type="time"
        label="Klockslag"
        outlined
        hint="Obligatorisk"
        persistent-hint
        :disabled="readonly"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { get } from 'vuex-pathify'
import { validDate, validTime } from '@/common/validationRules'

export default {
  name: 'OdocEventDateInput',

  props: {
    readonly: Boolean
  },

  data: () => ({
    validDate,
    validTime,
    date: null,
    time: null,
    datepicker: false
  }),

  computed: {
    eventDate: get('odoc/model@event_date')
  },

  watch: {
    eventDate: {
      handler(timeStart) {
        this.date = format(timeStart, 'yyyy-MM-dd')
        this.time = format(timeStart, 'HH:mm')
      },
      immediate: true
    },

    date(input) {
      const timeStart = new Date(`${input} ${this.time}`)
      this.$store.set('odoc/model@event_date', timeStart)
    },

    time(input) {
      const timeStart = new Date(`${this.date} ${input}`)
      this.$store.set('odoc/model@event_date', timeStart)
    }
  }
}
</script>
